/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce le configurazione Soglie del'Approvvigionamento Telepass
 */
(function() {
  'use strict';
  var PresaInCaricoFilialeCtrl = function(
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaTelepassSrvc,
    userSrvc,
    uiGridConstants,
    presaInCaricoFilialeSrvc,
    $q,
    domainSrvc,
    $state
    // propostaDefinizioneSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;
    this.uiGridConstants = uiGridConstants;
    this.presaInCaricoFilialeSrvc = presaInCaricoFilialeSrvc;
    this.$q = $q;
    this.domainSrvc = domainSrvc;
    this.$state = $state;

    this.propostaTelepassSrvc = propostaTelepassSrvc;
    // this.propostaDefinizioneSrvc = propostaDefinizioneSrvc;

    // Spinner
    this.spinner = this.propostaTelepassSrvc.spinner;

    this.gridOptions = {};

    this.stiliTabella = {
      height: '0px',
      width: '0px'
    };

    this.tableHeight = 0;
    this.tableWidth = 0;

    this.ricerca = {
      stato: '',
      dataDal: '',
      dataAl: ''
    };

    this.gestioneApparatiFl = false;

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE INTERFACCIA
     * -------------------------------------
     */

    this.salva = function(apparato) {
      self.messaggiFctr.resetMessages();
      self.spinner.showSpinner = true;

      self.presaInCaricoFilialeSrvc
        .promisePrendeInCaricoBancaApparato(apparato)
        .then(
          function(response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.spinner.showSpinner = false;
              return;
            }
            if (response.data.result) {
              //controlla se il stato del apparato è preso in carico e chiama al servizio
              // self.prendeInCaricoFilialeApparato(response.data.result);
              var message = {};
              message.type = 'I';
              message.message = 'Apparato caricato in magazzino';
              self.messaggiFctr.addMessage(message);
              self.recuperaDettaglioFlusso();
            }
          },
          function(error) {
            if (self.messaggiFctr.processaResponse(error)) {
              self.spinner.showSpinner = false;
              return;
            }
          }
        )
        .finally(function() {
          self.spinner.showSpinner = false;
        });
    };

    this.gestisci = function(dettaglioFlusso) {
      if (!dettaglioFlusso) {
        return;
      }
      self.gestioneApparatiFl = true;
    };

    this.recuperaDettaglioFlusso = function() {
      self.presaInCaricoFilialeSrvc
        .promiseRecuperaDettaglioFlusso()
        .then(function(response) {
          if (self.messaggiFctr.processaResponse(response)) {
            self.spinner.showSpinner = false;
            return;
          }
          self.dettaglioFlusso = response.data.result.quantitaSoglie[0];
        });
    };

    /*
     * -------------------------------------
     * METODI INIZIALIZZAZIONE
     * -------------------------------------
     */

    this.init = function() {
      self.messaggiFctr.resetMessages();
      self.spinner.showSpinner = true;

      labelSrvc.labelsPronte.then(function() {
        self.labelsPronte = true;

        self.recuperaDettaglioFlusso();

        $q.all([
          self.domainSrvc.promiseDomain('APPARATO'),
          self.domainSrvc.promiseDomain('ORDINE'),
          self.domainSrvc.promiseDomain('MAGAZZINO')
        ])
          .then(function(responses) {
            self.statiFlussi = responses[1];
            self.statiApparato = responses[0];
          })
          .finally(function() {
            self.spinner.showSpinner = false;
          });
      });
    };

    /*
     * -------------------------------------
     *        INIZIALIZZAZIONE
     * -------------------------------------
     */
    self.init();
  };

  PresaInCaricoFilialeCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPropostaSrvc',
    'TlpsUserSrvc',
    'uiGridConstants',
    'TlpsPresaInCaricoFilialeSrvc',
    '$q',
    'TlpsDomainSrvc',
    '$state'
    // 'TlpsDefinizioneSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsApprovvigionamento/presaInCarico/presaInCaricoFiliale/presaInCaricoFiliale.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var presaInCaricoFilialeComponent = {
    bindings: {
      steps: '<',
      currentStep: '<'
    },
    controller: PresaInCaricoFilialeCtrl,
    controllerAs: 'presaInCaricoFilialeCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('presaInCaricoFiliale', presaInCaricoFilialeComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsApprovvigionamento/presaInCarico/presaInCaricoFiliale/presaInCaricoFiliale.cmpt.js
// module id = 14
// module chunks = 0